"use client";

import React from "react";
import { NavigationCustomizationModal } from "../navigation-customization-modal";
import type { NavigationItem } from "../types";

interface HiddenNavCustomizationProps {
  navigationItems: NavigationItem[];
  visibleItems: NavigationItem[];
  hiddenItems: NavigationItem[];
  onSave: (items: NavigationItem[]) => void;
  onReset: () => void;
  onToggleVisibility: (itemId: string) => void;
  onMoveUp: (index: number) => void;
  onMoveDown: (index: number) => void;
  onMoveChildUp: (parentId: string, childId: string) => void;
  onMoveChildDown: (parentId: string, childId: string) => void;
  onToggleChildVisibility: (parentId: string, childId: string) => void;
  triggerRef: React.RefObject<HTMLDivElement | null>;
}

export function HiddenNavCustomization({
  navigationItems,
  visibleItems,
  hiddenItems,
  onSave,
  onReset,
  onToggleVisibility,
  onMoveUp,
  onMoveDown,
  onMoveChildUp,
  onMoveChildDown,
  onToggleChildVisibility,
  triggerRef,
}: HiddenNavCustomizationProps) {
  return (
    <div style={{ position: "absolute", left: "-9999px", top: "-9999px" }}>
      <NavigationCustomizationModal
        navigationItems={navigationItems}
        visibleItems={visibleItems}
        hiddenItems={hiddenItems}
        onSave={onSave}
        onReset={onReset}
        onToggleVisibility={onToggleVisibility}
        onMoveUp={onMoveUp}
        onMoveDown={onMoveDown}
        onMoveChildUp={onMoveChildUp}
        onMoveChildDown={onMoveChildDown}
        onToggleChildVisibility={onToggleChildVisibility}
        trigger={<div ref={triggerRef}>Navigation Customization Trigger</div>}
      />
    </div>
  );
}
